import React, { useState, useEffect, useContext } from "react";
import { styled } from "@mui/material/styles";
import {
  Box,

  CssBaseline,
  AppBar as MuiAppBar,
  Toolbar,

  Button,

} from "@mui/material";


import LoginDialog from "../../component/LoginDialog";
import verifyToken from "../../api/user/verifyToken";
import { AuthContext } from "../../context/AuthContext";
import api from "../../api/api";
import { useNavigate } from "react-router-dom";
const drawerWidth = 200;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
const role = {
    Admin: "Admin",
    Moderator: "Moderator",
    RegularUser: "RegularUser",
    Support: "Support",
  };
export default function LoginPage() {
  const [open, setOpen] = React.useState(false);
  const [loginOpen, setLoginOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);
  const handleLoginOpen = () => setLoginOpen(true);
  const userContext = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = localStorage.getItem("token");

    if (storedToken !== "" && storedToken !== null) {
      setToken(storedToken);
    }
  }, []);
  useEffect(() => {
    const fetchUser = async () => {
      try {
        setLoading(true);
        const responseData = await verifyToken();
        if (responseData.code === "000") {
          userContext.setUser(responseData.user);
        } else {
          userContext.setUser(null);
          localStorage.removeItem("token");
          api.defaults.headers.common["Authorization"] = "";
        }
      } catch (err) {
        userContext.setUser(null);
        localStorage.removeItem("token");
        api.defaults.headers.common["Authorization"] = "";
      } finally {
        setLoading(false);
      }
    };

    if (token !== "" && token !== null) {
      fetchUser();
    }
  }, [token]);
  useEffect(() => {
    if (userContext.user) {
      localStorage.setItem("user", JSON.stringify(userContext.user));
    }
    if(userContext.user?.Role===role.Admin){
   
        navigate('/dashboard')
    }
    if(userContext.user?.Role===role.Moderator){
      navigate('/dashboard')
    }
    if(userContext.user?.Role===role.Support){
      navigate('/dashboard')
    }

  }, [userContext.user]);

  function logout() {
    // Remove the token from localStorage

    localStorage.removeItem("token");
    userContext.setUser(null);
  }

  return (
    <>
      <Box sx={{ display: "flex", minHeight: "100vh", width: "100%" }} alignItems={'center'} justifyContent={'center'}>
        <CssBaseline />
        <AppBar color="secondary" position="fixed" open={open}>
          <Toolbar sx={{ justifyContent: "space-between" }}>

          </Toolbar>
        </AppBar>

          <Button
            fullWidth
            variant="outlined"
            color="info"

            onClick={handleLoginOpen}
            sx={{ fontWeight: "bold",fontSize:'23pt', width: "20%", height: "15vh",bgcolor:'white' }}
          >
            登入{" "}
          </Button>

      </Box>
      <LoginDialog
        openLogin={loginOpen}
        handleLoginClose={() => setLoginOpen(false)}
        setToken={setToken}
      />
    </>
  );
}
